import clsx from 'clsx'

const DEFAULT_ICON = '/linux.png'

export function hostOsIconSrc(iconFileName) {
  if (!iconFileName) return DEFAULT_ICON
  return iconFileName.startsWith('/') ? iconFileName : `/${iconFileName}`
}

export default function HostOsIcon({ iconFileName, className, title }) {
  const src = hostOsIconSrc(iconFileName)

  return (
    <img
      src={src}
      alt=""
      className={clsx('shrink-0 object-contain h-6 w-6', className)}
      loading="lazy"
      decoding="async"
      {...(title
        ? { role: 'img', 'aria-label': title }
        : { 'aria-hidden': true })}
    />
  )
}
